import * as Yup from 'yup';

const emailSchema = Yup.array().of(Yup.string().email());

export function shareAccessSchema(enableDailyQueueAssignedLocations: boolean) {
  return Yup.object().shape({
    emails: Yup.string()
      .required('Required Field')
      .test('emails_validation', 'One or more emails are invalid', (emails) =>
        emailSchema.isValidSync(emails?.split(',').map((email) => email.trim()))
      ),
    defaultAccountLocation: !enableDailyQueueAssignedLocations
      ? Yup.object().required('Required Field').nullable()
      : Yup.object().nullable(),
    accountLocations: enableDailyQueueAssignedLocations
      ? Yup.array().required('At least one location is required').nullable()
      : Yup.array().nullable(),
  });
}
